import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-grid-system";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { updateProductFields } from "../../../server/Product";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input, { Select } from "../../containers/InputForm";
import { getDictByKind } from "../../../server/Category";

const schema = yup.object({}).required();

const Logistica = () => {
  const {
    product,
    stationId,
    parameters: {
      _p_manufacturer,
      _p_provider,
      _p_storage_mode,
      _p_unload_manufacturer_package,
      _p_box_type,
      _p_box_storge_way,
    },
  } = useSelector((state) => ({
    product: state.selectedProduct.product,
    parameters: state.parameters,
    stationId: state.user.stationId,
  }));

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    defaultValues: { ...product },
    resolver: yupResolver(schema),
  });

  const storageConditionOptions = [
    { Id: "Frozen", Name: "קפוא" },
    { Id: "Refrigerated", Name: "מקורר" },
    { Id: "Room temperature", Name: "טמפרטורת חדר" },
    { Id: "Dry", Name: "יבש" },
    { Id: "Ambient", Name: "סביבה" },
    { Id: "Chilled", Name: "מצונן" },
    { Id: "Deep Frozen", Name: "קפוא עמוק" },
  ];

  const [brand, setBrand] = useState([]);
  const [subBrand, setSubBrand] = useState([]);

  useEffect(() => {
    const fetchFromDict = (kind, setKind) => {
      getDictByKind(kind)
        .then((res) => setKind(res))
        .catch((error) => console.error("Error fetching dictionary:", error));
    };
    fetchFromDict("sub-brand", setSubBrand);
    fetchFromDict("brand", setBrand);
  }, []);

  useEffect(() => {
    if (subBrand.length && product?.subBrand?.id)
      setValue("subBrand", product.subBrand.id);
    if (brand.length && product?.brand?.id) setValue("brand", product.brand.id);
  }, [product, subBrand, brand, setValue]);

  const tryUpdate = ({ target: { id, value } }) => {
    handleSubmit();
    if (!errors[id]) {
      let change;
      switch (id) {
        case "brand":
          change = {
            brand: (({ id, name }) => ({ id, name }))(
              brand.find((item) => item.id === value),
            ),
          };
          break;
        case "subBrand":
          change = {
            subBrand: (({ id, name }) => ({ id, name }))(
              subBrand.find((item) => item.id === value),
            ),
          };
          break;
        default:
          change = { [id]: value };
          break;
      }
      updateProductFields(stationId, product.productId, change);
    }
  };

  return (
    <form className="product-details-edit">
      <Container>
        <Row>
          <InputCol
            sm={4}
            name="userCompany"
            errors={errors}
            register={register}
            onBlur={tryUpdate}
            options={subBrand}
            label="יצרן"
          />
          {/*
          <InputCol
            errors={errors}
            label={"כמות במשטח"}
            name={"logisticsDetails.unitsPerPallet"}
            onBlur={tryUpdate}
            type="number"
            sm={4}
            register={register}
          />
          <InputCol
            errors={errors}
            label={"משקל ברוטו מארז יצרן"}
            name={"ManufacturerPackageWeight"}
            onBlur={tryUpdate}
            type="number"
            sm={4}
            register={register}
          />*/}
          <SelectCol
            sm={4}
            name="brand"
            errors={errors}
            register={register}
            onChange={tryUpdate}
            options={brand}
            label="ספק"
            value={watch("brand")}
          />
          <InputCol
            sm={4}
            name="logisticsDetails.masterCartonQuantity"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="כמות בארגז"
          />
          {/*
          <InputCol
            errors={errors}
            label={"משקל ברוטו"}
            name={"GrossWeight"}
            onBlur={tryUpdate}
            type="number"
            sm={4}
            register={register}
          />
          <SelectCol
            sm={4}
            name="ExchangeProviderId"
            errors={errors}
            register={register}
            onChange={tryUpdate}
            options={p_provider}
            label="ספק חילופי"
          />*/}
          <InputCol
            errors={errors}
            label={"כמות במארז יצרן"}
            name={"logisticsDetails.manufacturerPackQuantity"}
            onBlur={tryUpdate}
            type="number"
            sm={4}
            register={register}
          />
          {/*
          <InputCol
            errors={errors}
            label={"סטיית משקל ברוטו"}
            name={"GrossWeightLoss"}
            onBlur={tryUpdate}
            type="number"
            sm={4}
            register={register}
          />
          <SelectCol
            sm={4}
            name="ExchangeProviderId2"
            errors={errors}
            register={register}
            onChange={tryUpdate}
            options={p_provider}
            label="ספק חילופי2"
          />*/}
          <InputCol
            errors={errors}
            label={"כמות במיני מארז"}
            name={"logisticsDetails.miniPackQuantity"}
            onBlur={tryUpdate}
            type="number"
            sm={4}
            register={register}
          />
          {/*
          <SelectCol
            sm={4}
            name="BoxTypeId"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={p_box_type}
            label="סוג מיקום"
          />
          <SelectCol
            sm={4}
            name="BoxStorageWayId"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={p_box_storge_way}
            label="צור ת אחסון בארגז"
          />*/}
          <InputCol
            errors={errors}
            label={"מידות אריזות יצרן"}
            name={"logisticsDetails.manufacturerPackageSize"}
            onBlur={tryUpdate}
            type="number"
            sm={4}
            register={register}
          />
          <InputCol
            sm={4}
            name="logisticsDetails.itemHeight"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="גובה פריט"
          />
          {/*
          <SelectCol
            errors={errors}
            label={"צורת פריקת מארז יצרן"}
            onChange={tryUpdate}
            register={register}
            sm={4}
            name={"UnloadManufacturerPackageId"}
            options={p_unload_manufacturer_package}
          />
          <InputCol
            sm={4}
            errors={errors}
            name={"ManufacturerPackageQuantity"}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="יחידות במארז יצרן"
          />*/}
          <InputCol
            sm={4}
            name="logisticsDetails.volumeLevel"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="רמת נפח"
          />
          <InputCol
            sm={4}
            name="Action"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="רמת פעילות"
          />
          <SelectCol
            sm={4}
            name="logisticsDetails.storageCondition"
            errors={errors}
            register={register}
            onChange={tryUpdate}
            options={storageConditionOptions}
            label="טמפרטורת אחסון"
            value={watch("logisticsDetails.storageCondition")}
          />
          <InputCol
            sm={4}
            name="logisticsDetails.shelfLifeDays"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="חיי מדף בימים"
          />
          <InputCol
            sm={4}
            name="logisticsDetails.minimumExpirationDays"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="מינימום ימי פג תוקף"
          />
          <div className="check-box">
            <div className="checkbox-style">
              <Input
                name="logisticsDetails.separateProduct"
                errors={errors}
                onBlur={tryUpdate}
                register={register}
                type="checkBox"
                label=" מוצר מופרד"
              />
            </div>
            <div className="checkbox-style">
              <Input
                name="logisticsDetails.expiryAlert"
                errors={errors}
                onBlur={tryUpdate}
                register={register}
                type="checkBox"
                label=" התראת פג תוקף"
              />
            </div>
          </div>
        </Row>
      </Container>
    </form>
  );
};

const InputCol = ({ name, errors, label, type, register, sm, onBlur }) => {
  return (
    <Col sm={sm}>
      <Input
        name={name}
        errors={errors}
        onBlur={onBlur}
        register={register}
        label={label}
        type={type}
      />
    </Col>
  );
};
const SelectCol = ({
  name,
  errors,
  label,
  register,
  sm,
  options,
  onChange,
  value,
}) => {
  return (
    <Col sm={sm}>
      <Select
        name={name}
        errors={errors}
        {...register(name)}
        options={options}
        label={label}
        onChange={onChange}
        value={value}
      />
    </Col>
  );
};

export default Logistica;
